import { gql } from '@apollo/client'
import type { UseActionResult } from '@ztechapps/common.hook'
import { useError, useMutation } from '@ztechapps/common.hook'
import type {
  Adjustment,
  AdjustmentItem,
  CreateAndFulfillAdjustmentArgs,
  InventoryBySerialNumber,
} from '@ztechapps/common.contract'

const createAndAdjustAdjustmentQuery = gql`
  mutation createAndFulfillAdjustment($input: CreateAndFulfillAdjustmentArgs) {
    createAndFulfillAdjustment(input: $input) {
      _id
    }
  }
`

export type CreateAndAdjustArgs = {
  quantity: number
  items: AdjustmentItem[]
  tags: string[]
  remarks: string
  inventoryBySerialNumbers?: InventoryBySerialNumber[]
}

export const useCreateAndFulfillAdjustment = (productId: string): UseActionResult<Adjustment, CreateAndAdjustArgs> => {
  const [createAndAdjustAdjustment, , { error, loading }] = useMutation<
    { createAndAdjustAdjustment: Adjustment },
    CreateAndFulfillAdjustmentArgs
  >({
    query: createAndAdjustAdjustmentQuery,
    options: {
      mutationOptions: {
        refetchQueries: [
          'singleOrder',
          'allProduct',
          'singleProduct',
          'allInventoryTimeSeries',
          'allInventoryBySerialNumber',
        ],
      },
    },
  })
  const { onError } = useError()

  const onAction = async (formValues: CreateAndAdjustArgs): Promise<any> => {
    try {
      //select only those included values
      //and make set the quantity correctly, and trim down the items to be sent to the server
      const input = {
        remarks: formValues.remarks ?? '',
        items: [
          {
            product: { _id: productId },
            quantity: formValues.quantity,
            remarks: formValues.remarks ?? '',
            tags: formValues.tags,
            inventoryBySerialNumbers: formValues.inventoryBySerialNumbers ?? [],
          },
        ] as AdjustmentItem[],
      }

      return createAndAdjustAdjustment({ input })
    } catch (e) {
      onError(e)
    }
  }

  return [onAction, { loading, error }]
}
